import { render, staticRenderFns } from "./UserPersonalDetails.vue?vue&type=template&id=10b144fa&scoped=true"
import script from "./UserPersonalDetails.vue?vue&type=script&lang=js"
export * from "./UserPersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalDetails.vue?vue&type=style&index=0&id=10b144fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b144fa",
  null
  
)

export default component.exports